/**
 * Number of leading items of a one-line row that fit into `available` pixels
 * next to a trailing "+N" item, with `gap` pixels between items. Without a
 * measurable width (e.g. not laid out yet) all items stay.
 */
const countFittingItems = (available: number, itemWidths: number[], moreWidth: number, gap: number): number => {
    const total = itemWidths.reduce((sum, width) => sum + width, 0) + gap * Math.max(itemWidths.length - 1, 0);
    if (available <= 0 || total <= available) {
        return itemWidths.length;
    }

    let used = moreWidth;
    let count = 0;
    for (const width of itemWidths) {
        if (used + gap + width > available) {
            break;
        }
        used += gap + width;
        count++;
    }
    return Math.max(count, 1);
};

export { countFittingItems };
